import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=25661aa4&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"
import style0 from "./Notice.vue?vue&type=style&index=0&id=25661aa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25661aa4",
  null
  
)

export default component.exports